import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import ReactGA from 'react-ga';

import ChooserContainer from './containers/ChooserContainer';
import ResumeContainer from './containers/ResumeContainer';
import ExperimentsContainer from './containers/ExperimentsContainer';

import './style/styles.css';

class App extends Component {
  componentDidMount () {
    ReactGA.initialize('UA-4757323-1');
    ReactGA.pageview(window.location.href);
  }

  render() {
    return (
      <Router>
        <div>
          <Route exact path='/' component={ChooserContainer} />
          <Route path='/code' component={ResumeContainer} />
          <Route path='/experiments' component={ExperimentsContainer} />
        </div>
      </Router>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js